var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { eventChannel } from 'redux-saga';
import { call, delay, put, select, take, takeEvery, throttle, } from 'redux-saga/effects';
import * as gcAction from '../actions/gc';
import * as psAction from '../actions/process';
import * as wsAction from '../actions/websocket';
import { authenticateSelector } from '../selectors/authenticate';
function countdown() {
    return eventChannel(function (emitter) {
        var socketSubscriber = setInterval(function () {
            emitter(gcAction.inspectUnsubs());
        }, 60000);
        return function () {
            clearInterval(socketSubscriber);
        };
    });
}
var inspectSubs = function (_a) {
    var auth, wsocket, isConnected, wsocket_1, processData_1, processDict_1, subscribedPInst_1, processesToSub_1;
    var type = _a.type, payload = _a.payload;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0: return [4, select(authenticateSelector)];
            case 1:
                auth = _b.sent();
                return [4, select(function (state) { return state.websocket; })];
            case 2:
                wsocket = _b.sent();
                isConnected = wsocket.connected;
                _b.label = 3;
            case 3:
                if (!!isConnected) return [3, 6];
                return [4, delay(1000)];
            case 4:
                _b.sent();
                return [4, select(function (state) { return state.websocket; })];
            case 5:
                wsocket_1 = _b.sent();
                isConnected = wsocket_1.connected;
                return [3, 3];
            case 6:
                if (!(auth && auth.token)) return [3, 10];
                return [4, select(function (state) { return state.process.processData; })];
            case 7:
                processData_1 = _b.sent();
                processDict_1 = {};
                Object.keys(processData_1).forEach(function (processName) {
                    var refs = processData_1[processName].references;
                    refs.forEach(function (ref) {
                        processDict_1[ref.id] = ref.count;
                    });
                });
                return [4, select(function (state) { return state.websocket.data; })];
            case 8:
                subscribedPInst_1 = _b.sent();
                processesToSub_1 = [];
                Object.keys(processDict_1)
                    .filter(function (pid) { return processDict_1[pid] > 0; })
                    .forEach(function (pid) {
                    var isAlreadySubbed = (subscribedPInst_1.subscriptions || []).find(function (subId) { return subId === pid; });
                    if (!isAlreadySubbed) {
                        processesToSub_1.push(pid);
                    }
                });
                if (!(processesToSub_1.length > 0)) return [3, 10];
                return [4, put(wsAction.subscribeToProcess_AC(processesToSub_1))];
            case 9:
                _b.sent();
                _b.label = 10;
            case 10: return [2];
        }
    });
};
var inspectUnsubs = function (_a) {
    var auth, wsocket, isConnected, wsocket_2, processData_2, processDict_2, subscribedPInst_2, processesToUnsub_1;
    var type = _a.type, payload = _a.payload;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0: return [4, select(authenticateSelector)];
            case 1:
                auth = _b.sent();
                return [4, select(function (state) { return state.websocket; })];
            case 2:
                wsocket = _b.sent();
                isConnected = wsocket.connected;
                _b.label = 3;
            case 3:
                if (!!isConnected) return [3, 6];
                return [4, delay(1000)];
            case 4:
                _b.sent();
                return [4, select(function (state) { return state.websocket; })];
            case 5:
                wsocket_2 = _b.sent();
                isConnected = wsocket_2.connected;
                return [3, 3];
            case 6:
                if (!(auth && auth.token)) return [3, 10];
                return [4, select(function (state) { return state.process.processData; })];
            case 7:
                processData_2 = _b.sent();
                processDict_2 = {};
                Object.keys(processData_2).forEach(function (processName) {
                    var _a;
                    var refs = (_a = processData_2[processName].references, (_a !== null && _a !== void 0 ? _a : []));
                    refs.forEach(function (ref) {
                        processDict_2[ref.id] = ref.count;
                    });
                });
                return [4, select(function (state) { return state.websocket.data; })];
            case 8:
                subscribedPInst_2 = _b.sent();
                processesToUnsub_1 = [];
                Object.keys(processDict_2)
                    .filter(function (pid) { return processDict_2[pid] === 0; })
                    .forEach(function (pid) {
                    var isAlreadySubbed = (subscribedPInst_2.subscriptions || []).find(function (subId) { return subId === pid; });
                    if (isAlreadySubbed) {
                        processesToUnsub_1.push(pid);
                    }
                });
                if (!(processesToUnsub_1.length > 0)) return [3, 10];
                return [4, put(wsAction.unsubscribeToProcess_AC(processesToUnsub_1))];
            case 9:
                _b.sent();
                _b.label = 10;
            case 10: return [2];
        }
    });
};
export function startGC() {
    var chan, action;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4, call(countdown)];
            case 1:
                chan = _a.sent();
                _a.label = 2;
            case 2:
                _a.trys.push([2, , 7, 8]);
                _a.label = 3;
            case 3:
                if (!true) return [3, 6];
                return [4, take(chan)];
            case 4:
                action = _a.sent();
                return [4, put(action)];
            case 5:
                _a.sent();
                return [3, 3];
            case 6: return [3, 8];
            case 7:
                console.log('countdown terminated');
                return [7];
            case 8: return [2];
        }
    });
}
var actionWatcher = function () {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4, takeEvery(gcAction.types.START_GC, startGC)];
            case 1:
                _a.sent();
                return [4, takeEvery(gcAction.types.INSPECT_UNSUBS, inspectUnsubs)];
            case 2:
                _a.sent();
                return [4, throttle(500, [
                        psAction.types.SET_PROCESS_DATA,
                        psAction.types.EDIT_PROCESS_SUCCESS_DATA,
                        psAction.types.ADD_PROCESS_CLAIM,
                        psAction.types.REMOVE_PROCESS_CLAIM,
                    ], inspectSubs)];
            case 3:
                _a.sent();
                return [2];
        }
    });
};
export default actionWatcher;
//# sourceMappingURL=gc.js.map